import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Platform } from '../../platform/platform.detect';
import { loadCapacitorPushNotifications } from '../../platform/capacitor.loader';

// AIDEV-NOTE: Deep Link handler para notificacoes nativas clicadas com app fechado.
//             Universal Links (iOS) e App Links (Android) redirecionam aqui.
export function DeepLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Platform.isNative()) return;

    let cleanup: (() => void) | undefined;

    loadCapacitorPushNotifications()
      .then((mod) => {
        const { PushNotifications } = mod;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        PushNotifications.addListener('pushNotificationActionPerformed', (action: any) => {
          const data = action.notification.data as Record<string, string> | undefined;
          if (data?.route) {
            navigate(data.route);
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }).then((handle: any) => {
          cleanup = () => handle.remove();
        });
      })
      .catch(() => {
        // @capacitor/push-notifications pode nao estar instalado em PWA
      });

    return () => {
      cleanup?.();
    };
  }, [navigate]);

  return null;
}
